<div class="discriptive-type-container">
  <div class="main-dev" *ngIf="display && !isListMode">
    <div class="btn-wrapper descriptive-main">
      <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
        <span>{{'questions.typeOfQuestions.descriptiveRichText.btnBack' | translate}}</span>
      </button>
      <span class="spacer"></span>
      <button [disabled]="userForm.invalid" mat-flat-button color="" class="btn-primary" aria-label="Save" (click)='saveQuestion()'>
        <span>{{'questions.typeOfQuestions.descriptiveRichText.btnSave' | translate}}</span>
      </button>
    </div>

    <form [formGroup]="userForm">
      <ng-container>
        <div class="filter-section">
          <div class="body-section title">
            <mat-icon>library_add</mat-icon> &nbsp;
            <span>{{'questions.typeOfQuestions.descriptiveRichText.title' | translate}}</span>
          </div>
          <div class="body-section-2" formGroupName="questiondescription">
            <label class="que-label">{{'questions.typeOfQuestions.descriptiveRichText.labelQuest' | translate}}</label>
            <ckeditor #myEditor formControlName="description" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
            <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <!-- <ckeditor formControlName="description" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->
          </div>
        </div>
      </ng-container>
      <div class="input2">
        <div class="seqInput"><label class="Questions-score">{{'questions.typeOfQuestions.descriptiveRichText.labelQuestScore' | translate}}<span class="error">*</span></label>
          <input type="number" formControlName="correctPoints" class="form-control widthInput" min="0" max="9999.99" step=".01"
          (input)="validateInput($event, userForm.get('correctPoints').value, 'options')" (keypress)="omit_special_char($event)">

          <!-- <input min="1" class="form-control widthInput" type="number" formControlName="correctPoints"
            onkeypress="if(this.value.length == 4 ) return false;"
            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
        </div>
        <div class="seqInput">
          <label class="Questions-score">{{'questions.typeOfQuestions.descriptiveRichText.labelCharLimit' | translate}}<span class="error">*</span></label>
          <input min="1" class="form-control" type="number" onkeyup="if(this.value.length == 6 ) return false;" max="32000"
            formControlName="maximumcharacterForFreetext"
            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
          <mat-error *ngIf="this.userForm.controls['maximumcharacterForFreetext'].value >= 32001">{{'questions.typeOfQuestions.descriptiveRichText.charLimitError1' | translate}}</mat-error>
        </div>
      </div>
      <div class="exp-panel p-0">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'questions.typeOfQuestions.descriptiveRichText.accordian.title' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="container-fluid  body-section-2">
              <div class="row">
                <div class="col-md-2">
                  <div class="mat-checkbox-scoring">
                    <mat-checkbox name="autoscoring" formControlName="autoScoring" [checked]="false" [disabled]="true">
                      <span class="font-w"> <b>{{'questions.typeOfQuestions.descriptiveRichText.accordian.checkbox' | translate}}</b> </span></mat-checkbox>
                  </div>
                </div>
                <br>
                <br>
                <div class="col-md-2">
                  <div class="scoring-check">
                    <div class="invalid-feedback">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="form-label">
                    <label>{{'questions.typeOfQuestions.fillInTheBlanksText.accordian.selectOptions.option1.label' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-3 bg-scoring">
                  <mat-form-field class="scoring-type" appearance="fill">
                    <mat-select formControlName="scoringTypeExactMatch">
                      <mat-option [value]="option.id == 1 ? 'true' : 'false'" *ngFor="let option of QuestionScoringType" selected>{{option.title}}</mat-option>

                    </mat-select>
                    <div class="invalid-feedback">
                    </div>
                  </mat-form-field>
                </div>
              </div>
              <div class="row items-center">
                <!-- <div class="col-md-2">
                  <label class="form-label score-labels">{{'questions.typeOfQuestions.descriptiveRichText.accordian.selectOptions.option2' | translate}}</label>
                </div>
                <div class="col-md-3" id="penalty">
                  <input [formControlName]="reuseProp.penaltyPoints" class="form-control" type="number" min="" [attr.disabled]="true">
                </div>
                <div *ngIf="!userForm.get(reuseProp.penaltyPoints).valid && userForm.get(reuseProp.penaltyPoints).touched">
                  Required and only zero or positive numbers allowed
                </div> -->
                <div class="col-md-2">

                  <label class="form-label score-labels" required>{{'questions.typeOfQuestions.fillInTheBlanksText.accordian.selectOptions.option3.label' | translate}}</label>

                </div>
                <div class="col-md-3">
                  <input type="number" formControlName="minScoreIfAttempt" class="form-control" min="0" max="9999.99" step=".01"
                  (input)="validateInput($event, userForm.get('correctPoints').value, 'minimumScore')" (keypress)="omit_special_char($event)">

                  <!-- <input [formControlName]="reuseProp.minScoreIfAttempt" type="number" min="0" max="9999" class="form-control"
                  onkeypress="if(this.value.length == 4 ) return false;"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->

                  <div *ngIf="!this.userForm.get(reuseProp.minScoreIfAttempt).valid &&
                        (this.userForm.get(reuseProp.minScoreIfAttempt).touched || this.userForm.get(reuseProp.minScoreIfAttempt).dirty)" class="alert alert-danger zero">
                        {{'questions.typeOfQuestions.fillInTheBlanksText.accordian.selectOptions.option3.errorMsg1' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
  <div *ngIf="!display">
    <app-choose-question-type></app-choose-question-type>
  </div>

  <div *ngIf="isListMode">
    <app-question-list></app-question-list>
  </div>
</div>
